<template>
    <div class="document-info">
      <h2>Document Information</h2>
      <p>{{ DocumentName }}</p>
    </div>
  </template>
  
  <script>
  export default {
    props: ['DocumentName'], // Receive DocumentName as a prop
  
    // Example of using the DocumentName prop to fetch data (pseudo-code)
    mounted() {
      // This is where you would fetch more information about the document using the DocumentName
      // For example: this.fetchDocumentInfo(this.DocumentName);
      console.log('Fetching information for document:', this.DocumentName);
    },
  
    // Example method (pseudo-code)
    methods: {
      async fetchDocumentInfo(documentName) {
        // Fetch document info logic here...
        console.log(`Fetch information for document: ${documentName}`);
        // Assume we're fetching data from an API and then setting it to some data property
      },
    },
  };
  </script>
  
  <style scoped>
  .document-info {
    padding: 20px;
    border: 1px solid #ccc;
    margin-top: 20px;
  }
  </style>
  